<main class="main-dashboard">
    <article class="main-canvas">
      <section class="canvas-container">
        <section class="dashboard-items">
          <div class="canvas-item">
            <div class="canvas-header row justify-content-between align-items-center" style="padding: 0 !important;">
              <nav class="col-sm-8 p-0">
                <div class="nav nav-tabs border-0" id="nav-tab">
                  <a class="nav-item nav-link title  p-2" (click)="timesheetPage()" role="tab">
                    <h2> Timesheet</h2>
                  </a>
                  <a class="nav-item nav-link title active p-2">
                    <h2>Project Task</h2>
                  </a>
                </div>
              </nav>
              <div class="col-sm-4 d-flex justify-content-end">
                <div class="edit" *ngIf="selectedCheckboxData.length === 1">
                  <button type="button" title="Edit" (click)="editOpenModal()" data-bs-toggle="modal"
                    data-bs-target="#createTask">
                    <span><i class="ri-pencil-line"></i></span>
                  </button>
                </div>
                <div class="delete" *ngIf="selectedCheckboxData.length > 0">
                  <button type="button" title="Delete" data-bs-toggle="modal" data-bs-target="#deleteSaleTask"
                    (click)="deleteOpenModal()">
                    <span><i class="ri-delete-bin-5-line"></i></span>
                  </button>
                </div>
                <div class=" add-btn">
                  <button type="button" title="Create" (click)="createOpenModal()" data-bs-toggle="modal"
                    data-bs-target="#createTask" class="btn btn-icon">
                    <i class="ri-add-line"></i>
                  </button>
                </div>
                <button type="button" data-bs-toggle="modal" data-bs-target="#createTimesheet" (click)="createTSOpenModal()" id="confimationBtn" style="display: none;"></button>
              </div>
            </div>
  
            <ag-grid-angular style="height: 620px;" class="ag-theme-material" (gridReady)="onGridReady($event)"
              [rowData]="rowData" [columnDefs]="columnDefs" pagination="true" [defaultColDef]="defaultColDef"
              [suppressRowClickSelection]="true" [rowSelection]="rowSelection"
              (selectionChanged)="onSelectionChanged($event)" paginationPageSize=10>
            </ag-grid-angular>
          </div>
        </section>
      </section>
    </article>
  </main>
  
  <!-- Create new createTask -->
  <div class="modal fade bd-example-modal-lg" id="createTask">
    <div class="modal-dialog modal-lg">
      <div class="modal-content pl-5 pr-5">
        <form [formGroup]="projectTaskGridForm">
          <div class="modal-header">
            <h5 class="modal-title">Task</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-sm-6">
                <div class="input">
                  <div class="input-item">
                    <input type="text" list="projectList" formControlName="projectV2Id" (change)="onProjectChange($event)" required>
                    <datalist id="projectList">
                      <option [value]="item" *ngFor="let item of projectDropdownList"></option>
                    </datalist>
                    <label class="floating-label-special">Project Name*</label>
                    <i class="ri-file-list-line"></i>
                  </div>
                  <mat-error *ngIf="f.projectV2Id.touched && f.projectV2Id.invalid" class="alert alert-danger">
                    <mat-error *ngIf="f.projectV2Id.errors.required">Project Name is required</mat-error>
                </mat-error>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="input">
                  <div class="input-item">
                    <select formControlName="projectV2TaskName">
                      <option value="" disabled>Select Task Name</option>
                      <option *ngFor="let task of taskList" value="{{task}}">{{task}}</option>
                    </select>
                    <label class="floating-label-special">Task Name*</label>
                    <i class="ri-task-line"></i>
                  </div>
                  <mat-error *ngIf="f.projectV2TaskName.touched && f.projectV2TaskName.invalid" class="alert alert-danger">
                    <mat-error *ngIf="f.projectV2TaskName.errors.required">Task Name is required</mat-error>
                </mat-error>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="input">
                  <div class="input-item">
                    <input type="text" formControlName="taskOwnerName" disabled>
                    <label class="floating-label-special">Task Owner*</label>
                    <i class="ri-user-3-line"></i>
                  </div>
                  <mat-error *ngIf="f.taskOwnerName.touched && f.taskOwnerName.invalid" class="alert alert-danger">
                    <mat-error *ngIf="f.taskOwnerName.errors.required">Task Owner is required</mat-error>
                  </mat-error>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="input">
                    <div class="input-item">
                        <select formControlName="partList">
                            <option value="" disabled>Select Part List</option>
                            <option *ngFor="let pl of partList" value="{{pl}}">{{pl}}</option>
                        </select>
                        <label class="floating-label-special">Part List*</label>
                        <i class="ri-task-line"></i>
                    </div>
                    <mat-error *ngIf="f.partList.touched && f.partList.invalid" class="alert alert-danger">
                        <mat-error *ngIf="f.partList.errors.required">Part List is required</mat-error>
                    </mat-error>
                </div>
            </div>
              <div class="col-sm-6">
                <div class="input">
                  <div class="input-item">
                    <input type="date" formControlName="startDate" min="{{this.minStartDate}}" max="{{this.minEndDate}}">
                    <label class="floating-label-special">Start Date*</label>
                    <i class="ri-calendar-todo-line"></i>
                  </div>
                  <mat-error *ngIf="f.startDate.touched && f.startDate.invalid" class="alert alert-danger">
                    <mat-error *ngIf="f.startDate.errors.required">Start Date is required</mat-error>
                  </mat-error>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="input">
                  <div class="input-item">
                    <input type="date" formControlName="endDate" min="{{this.minStartDate}}" max="{{this.minEndDate}}">
                    <label class="floating-label-special">End Date*</label>
                    <i class="ri-calendar-event-line"></i>
                  </div>
                  <mat-error *ngIf="f.endDate.touched && f.endDate.invalid" class="alert alert-danger">
                    <mat-error *ngIf="f.endDate.errors.required">End Date is required</mat-error>
                  </mat-error>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="input">
                  <div class="input-item">
                    <input type="text" formControlName="estimatedHours">
                    <label class="floating-label-special">Estimate Time in Hours(ex. 10.5)</label>
                    <i class="ri-timer-line"></i>
                  </div>
                  <mat-error *ngIf="f.estimatedHours.touched && f.estimatedHours.invalid" class="alert alert-danger">
                    <mat-error *ngIf="f.estimatedHours.errors.required">Estimate Time is required</mat-error>
                  </mat-error>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="input">
                  <div class="input-item">
                    <label class="floating-label floating-label-special">Status*</label>
                    <select formControlName="status" placeholder="status">
                      <option value="" disabled selected>Select Status</option>
                      <option value="open">Open</option>
                      <option value="close">Close</option>
                    </select>
                    <i class="ri-phone-line"></i>
                  </div>
                  <mat-error *ngIf="f.status.touched && f.status.invalid" class="alert alert-danger">
                    <mat-error *ngIf="f.status.errors.required">Status is required</mat-error>
                  </mat-error>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="input">
                  <div class="input-item">
                    <input type="date" formControlName="plannedStartDate" disabled>
                    <label class="floating-label-special">Planned Start Date</label>
                    <i class="ri-calendar-todo-line"></i>
                  </div>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="input">
                  <div class="input-item">
                    <input type="date" formControlName="plannedEndDate" disabled>
                    <label class="floating-label-special">Planned End Date</label>
                    <i class="ri-calendar-event-line"></i>
                  </div>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="input">
                  <div class="input-item">
                    <input type="text" formControlName="completionPercentage" disabled>
                    <label class="floating-label-special">Percent of Completion(Ex. 25 means 25%)</label>
                    <i class="ri-timer-line"></i>
                  </div>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="input">
                  <div class="input-item">
                    <input type="text" formControlName="predecessorProjectV2TaskName" disabled>
                    <label class="floating-label-special">Predecessor task</label>
                    <i class="ri-file-list-2-line"></i>
                  </div>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="input">
                  <div class="input-item">
                    <input type="text" formControlName="successorProjectV2taskName" disabled>
                    <label class="floating-label-special">Successor task</label>
                    <i class="ri-file-list-2-line"></i>
                  </div>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="input">
                  <div class="input-item">
                    <label class="floating-label floating-label-special">Planned Status</label>
                    <select formControlName="status" placeholder="plannedStatus" disabled>
                      <option value="" disabled selected>Select Status</option>
                      <option value="open">Open</option>
                      <option value="close">Close</option>
                    </select>
                    <i class="ri-phone-line"></i>
                  </div>
                </div>
              </div>
              <div class="col-sm-12">
                <div class="input">
                  <div class="input-item">
                    <textarea name="" id="" cols="12" rows="3" formControlName="description"></textarea>
                    <label class="floating-label-special">Description</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" id="closeCreateModal" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
            <button type="button" class="btn btn-primary" *ngIf="modeAction === 1" [disabled]="!projectTaskGridForm.valid" (click)="createProjectTask()">Create</button>
            <button type="button" class="btn btn-primary" *ngIf="modeAction === 2" [disabled]="!projectTaskGridForm.valid" (click)="updateProjectTask()">Update</button>
          </div>
        </form>
      </div>
    </div>
  </div>
  
  
  <!-- Create new Timesheet -->
  <div class="modal fade bd-example-modal-lg" id="createTimesheet" tabindex="-1">
      <div class="modal-dialog modal-lg">
        <div class="modal-content pl-5 pr-5">
          <form [formGroup]="timesheetForm">
            <div class="modal-header">
              <h5 class="modal-title">Create Timesheet</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-sm-6">
                  <div class="input">
                    <div class="input-item">
                      <input type="text" formControlName="assignedTo" disabled/>
                      <label class="floating-label-special">Assign To</label>
                      <i class="ri-user-line"></i>
                    </div>
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="input">
                    <div class="input-item">
                      <input type="text" formControlName="projectV2Id" disabled/>
                      <label class="floating-label-special">Project</label>
                      <i class="ri-shield-user-line"></i>
                    </div>
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="input">
                    <div class="input-item">
                      <input type="text" formControlName="subprojectV2Id" disabled/>
                      <label class="floating-label-special">Sub Project</label>
                      <i class="ri-shield-user-line"></i>
                    </div>
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="input">
                    <div class="input-item">
                      <input type="text" formControlName="projectV2ManagerName" disabled/>
                      <label class="floating-label-special">Project Manager</label>
                      <i class="ri-shield-user-line"></i>
                    </div>
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="input">
                    <div class="input-item">
                      <input formControlName="projectV2LeadName" type="text" disabled/>
                      <label class="floating-label-special">Project Lead</label>
                      <i class="ri-time-line"></i>
                    </div>
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="input">
                    <div class="input-item">
                      <input type="text" formControlName="projectV2TaskId" disabled/>
                      <label class="floating-label-special">Project Task</label>
                      <i class="ri-time-line"></i>
                    </div>
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="input">
                    <div class="input-item">
                      <input formControlName="businessGroup" disabled>
                      <label class="floating-label-special">Business Group</label>
                      <i class="ri-menu-unfold-line"></i>
                    </div>
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="input">
                    <div class="input-item">
                      <input formControlName="commodity" disabled>
                      <label class="floating-label-special">Commodity Information</label>
                      <i class="ri-menu-unfold-line"></i>
                    </div>
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="input">
                    <div class="input-item">
                      <input formControlName="partList" disabled>
                      <label class="floating-label-special">Part List Information</label>
                      <i class="ri-menu-unfold-line"></i>
                    </div>
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="input">
                    <div class="input-item">
                      <input formControlName="taskStartDate" type="date" disabled required />
                      <label class="floating-label-special">Task Start Date</label>
                      <i class="ri-calendar-check-line"></i>
                    </div>
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="input">
                    <div class="input-item">
                      <input formControlName="taskEndDate" type="date" disabled />
                      <label class="floating-label-special">Task End Date</label>
                      <i class="ri-calendar-check-line"></i>
                    </div>
                  </div>
                </div>
                <div class="col-sm-6">
                </div>
                <div class="col-sm-6">
                  <div class="input">
                    <div class="input-item">
                      <input formControlName="startDate" min="{{this.minTSStartDate}}" max="{{this.minTSEndDate}}" (change)="onChangeEvent($event)" type="date" required />
                      <label class="floating-label-special">Start Date*</label>
                      <i class="ri-calendar-check-line"></i>
                    </div>
                    <mat-error *ngIf="t.startDate.touched && t.startDate.invalid" class="alert alert-danger">
                      <mat-error *ngIf="t.startDate.errors.required">Start Date is required</mat-error>
                    </mat-error>
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="input">
                    <div class="input-item">
                      <input formControlName="endDate" type="date" disabled />
                      <label class="floating-label-special">End Date*</label>
                      <i class="ri-calendar-check-line"></i>
                    </div>
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="input">
                    <div class="input-item">
                      <input formControlName="totalHours" type="number" min="0" max="16" />
                      <label class="floating-label-special">Punch Hours</label>
                      <i class="ri-time-line"></i>
                    </div>
                    <mat-error *ngIf="t.totalHours.touched && t.totalHours.invalid" class="alert alert-danger">
                      <mat-error *ngIf="t.totalHours.errors.required">Hours are required</mat-error>
                    </mat-error>
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="input">
                    <div class="input-item">
                      <label class="floating-label-special">Status*</label>
                      <select formControlName="status">
                        <option value="" disabled selected>Select Status</option>
                        <option value="Save">Save</option>
                        <option value="Submit">Submit</option>
                      </select>
                      <i class="ri-24-hours-line"></i>
                    </div>
                    <mat-error *ngIf="t.status.touched && t.status.invalid" class="alert alert-danger">
                      <mat-error *ngIf="t.status.errors.required">Status is required</mat-error>
                    </mat-error>
                  </div>
                </div>
                <div class="col-sm-12">
                  <div class="input">
                    <div class="input-item">
                      <textarea name="" id="" cols="20" rows="4" formControlName="description"></textarea>
                      <label class="floating-label-special">Description</label>
                      <i class="ri-file-list-line"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" id="closeModalTimeSheet" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
              <button type="button" class="btn btn-primary" [disabled]="!timesheetForm.valid" *ngIf="modeAction === 1" (click)="createTimesheet()" >Create</button>
            </div>
          </form>
        </div>
      </div>
    </div>
